// Vue
// A progressive, incrementally-adoptable JavaScript framework for building UI on the web.
// https://github.com/vuejs/vue
import Vue from 'vue'

// Vue Style
// A lightweight custom CSS variable plugin for Vue.js 2.0.
// https://github.com/strantr/vue-style
import VueStyle from './plugins/vue-style'

// Validações
import VeeValidate from './plugins/vee-validate'

// Bootstrap 3
import 'bootstrap/dist/css/bootstrap.min.css'

// Bootstrap 3 Custom
import stylesheet from './assets/css/app.less'

import App from './App.vue'

import router from './router'
import store from './store'
import plugins from './plugins'

// PWA
import './registerServiceWorker'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import SelectResourceField from './components/select-resource/SelectResourceField'

// Vue
// Usando plugins, pode opcionalmente passar algumas opções
// https://br.vuejs.org/v2/guide/plugins.html
Vue.use(VueStyle)
Vue.use(VeeValidate)
Vue.use(plugins)
Vue.use(Autocomplete)

// Configs
Vue.config.productionTip = false

new Vue({
  router,
  store,
  stylesheet: stylesheet,
  render: h => h(App)
}).$mount('#app')
